import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b525144")

_pushScopeId("data-v-2b525144")
const _hoisted_1 = { class: "flex bg-yellow-300" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "bg-yellow-500 demo" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "example" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
})